
import { Component, Mixins } from "vue-property-decorator";
import WizardMixin from "../wizard.mixin";
import { mapState } from "vuex";
import { WizardInformationFormDto, WizardRateFormDto } from "@/types/wizard.type";
import { WizardStep } from "@/types/enums.type";
import ValidatedFormMixin from "@/common/mixins/validated-form.mixin";
import { PositionDto } from "@/types/position.type";

@Component({
  computed: {
    ...mapState('Wizard', {
      forms: 'rateForms',
      infoForm: 'infoForm',
      positions: 'positions'
    })
  }
})
export default class WizardRatesComponent extends Mixins(WizardMixin, ValidatedFormMixin) {
  infoForm!: WizardInformationFormDto;
  forms!: WizardRateFormDto[];
  positions!: PositionDto[];

  WizardStep = WizardStep;
  
  async created(): Promise<void> {
    if (this.forms.length) {
      return;
    }

    this.setLoading(true);

    this.$store.commit('Wizard/updateField', { path: 'rateForms', value: [] });

    await this.$store.dispatch("Wizard/getPositions");
    
    for (const position of this.positions) {
      this.forms.push({
        position: position.name,
        rate: 0,
        positionId: position.id,
      });
    }

    this.setLoading(false);
  }

  finishForm(): void {
    if (this.forms.length) {
      this.next(WizardStep.Payrolls);
    }

    this.$validator.validateAll();
  }
}
